export default __webpack_public_path__ + "static/media/pakora.68799230.jpg";